import { useTranslation } from "react-i18next";
import CustomTable from "components/ReactTable/CustomTable";
import React, { useState, useEffect, useMemo } from "react";
import { Button, Container, Card, CardTitle } from "reactstrap";
import ReactBSAlert from "react-bootstrap-sweetalert";
import { successToaster } from "components/common/toast";
import { ErrorToaster } from "components/common/toast";
import { DeleteSectionSubCategoriesAPI } from "network/categoryAPI";
import { GetSectionSubCategoriesAPI } from "network/categoryAPI";
import AddSubCategorySectionModal from "components/modal/AddSubCategorySectionModal";
import TableFilter from "components/TableFilter/TableFilter";

const SubCategorySection = ({ sectionData }) => {
  const { t } = useTranslation("category");
  const [subCategoriesData, setSubCategoriesData] = useState([]);
  const [singleSubCategory, setSingleSubCategory] = useState(null);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [alert, setAlert] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [fetchTrigger, setFetchTrigger] = useState(false);
  const [sort, setSort] = useState("");
  const [search, setSearch] = useState("");
  const [categories, setCategories] = useState("");
  const [confirmLoading, setConfirmLoading] = useState(false);

  const pageSize = 10;
  const resetState = () => {
    setSearch("");
    setSort("");
    setCategories("");
    setCurrentPage(1);
    setSubCategoriesData([]);
    setTotalPages(1);
    setSingleSubCategory(null);
    setIsAddModalOpen(false);
    setAlert(null);
  };

  useEffect(() => {
    resetState();
  }, [sectionData]);

  const fetchSubCategory = async (currentPage) => {
    try {
      setIsLoading(true);
      const response = await GetSectionSubCategoriesAPI(
        sectionData?.uuid,
        currentPage,
        pageSize,
        search,
        categories?.value,
        sort?.value
      );

      if (response.success) {
        setSubCategoriesData(response?.data?.sub_categories);
        setIsLoading(false);
        setTotalPages(response?.data?.total_pages);
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  useEffect(() => {
    setCurrentPage(1);
    setFetchTrigger((prev) => !prev);
  }, [categories, search, sort]);

  useEffect(() => {
    fetchSubCategory(currentPage);
  }, [currentPage, fetchTrigger, sectionData]);

  const handleModalOpen = (items) => {
    setSingleSubCategory(items);
    setIsAddModalOpen(true);
  };

  const warningWithConfirmMessage = (id) => {
    setConfirmLoading(false);
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={t("confirm.title")}
        onConfirm={() => successDelete(id)}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        confirmBtnText={t("confirm.yes")}
        cancelBtnText={t("confirm.cancel")}
        showCancel
        btnSize=""
        confirmBtnDisabled={confirmLoading}
      >
        {t("sub.confirmDelete")}
      </ReactBSAlert>
    );
  };
  const hideAlert = () => {
    setAlert(null);
  };
  const successDelete = async (id) => {
    try {
      setConfirmLoading(true);

      const response = await DeleteSectionSubCategoriesAPI(
        sectionData?.uuid,
        id
      );

      if (response.success) {
        successToaster(t("sub.deleted"));
        setSubCategoriesData((prevUsers) =>
          prevUsers.filter((value) => value?.uuid !== id)
        );

        hideAlert();
      } else {
        hideAlert();
        ErrorToaster(t("sub.deleteFailed"));
      }
    } catch (error) {
      hideAlert();
      ErrorToaster(t("sub.deleteFailed"));
    } finally {
      setConfirmLoading(false);
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: t("sub.colName"),
        accessor: "name",
        Cell: ({ value }) => value || "-",

        width: 80,
      },

      // {
      //   Header: "Category",
      //   accessor: "category",
      //   className: "text-center",
      //   width: 120,
      //   Cell: ({ row }) => (
      //     <div key={row?.original?.uuid}>
      //       <p>
      //         {row?.original?.categories?.length > 0
      //           ? row.original.categories
      //               .map((category) => category?.name)
      //               .join(", ")
      //           : "-"}
      //       </p>
      //     </div>
      //   ),
      // },
      {
        Header: t("sub.colDescription"),
        accessor: "description",

        Cell: ({ value }) => value || "-",
      },

      {
        Header: t("sub.colAction"),
        accessor: "action",
        width: 30,
        Cell: ({ row }) => (
          <div className="d-flex gap-3">
            <i
              className="tim-icons icon-pencil mr-3 text-warning pointer"
              onClick={() => handleModalOpen(row.original)}
            ></i>
            <i
              className="tim-icons icon-trash-simple text-danger pointer"
              onClick={() => warningWithConfirmMessage(row.original.uuid)}
            ></i>
          </div>
        ),
      },
    ],
    [t]
  );
  const handleOpenModel = () => {
    setSingleSubCategory(null);
    setIsAddModalOpen(true);
  };
  return (
    <>
      <div className="content">
        {alert}
        <Container>
          <Card className="p-4">
            <div className="d-flex gap-16 flex-wrap justify-content-between align-items-center mb-4">
              <CardTitle tag="h2" className="mb-0">
                {t("sub.title")}
              </CardTitle>
              <Button
                className="text-capitalize"
                color="primary"
                onClick={handleOpenModel}
                // disabled={!addCategoryOptions.length > 0}
              >
                {t("sub.add")}
              </Button>
            </div>
            <TableFilter
              search={search}
              setSearch={setSearch}
              sort={sort}
              setSort={setSort}
              showSearch
              showSort
            />
            <CustomTable
              columns={columns}
              data={subCategoriesData || []}
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
              showPagination={totalPages > 1}
              isLoading={isLoading}
              minWidth="600px"
            />
          </Card>
        </Container>
        {/* {addCategoryOptions.length > 0 && ( */}
        <AddSubCategorySectionModal
          open={isAddModalOpen}
          setOpen={setIsAddModalOpen}
          data={singleSubCategory}
          setData={setSingleSubCategory}
          setFetchTrigger={setFetchTrigger}
          section={sectionData}
          setSubCategoriesData={setSubCategoriesData}
        />
      </div>
    </>
  );
};

export default SubCategorySection;
